import { cmToMm } from '../../utils/number-converter';
import NumberFormatter from '../../utils/number-formatter';

export function renderVerticalHelperMeasurements(points, mousepoint, svgGroup, view) {
  const g = com.parkside.measure_geometry;
  const poly = g.arrayOfPointsSort(points, 'y');
  const profiles = [];
  const containerPosition = dojo.position(view.canvasElement, true);
  const vpx2cm = 1; //TODO Review
  const leftEdgeOffset = 0;
  const numberFormatter = new NumberFormatter({});

  // add area borders also to profile array for simpler distance calculation
  profiles.splice(0, 0, {
    start: {
      x: 0,
      y: poly[0].y,
    },
    end: {
      x: 0,
      y: poly[0].y,
    },
  });

  profiles.push({
    start: {
      x: 0,
      y: mousepoint.y,
    },
    end: {
      x: 0,
      y: mousepoint.y,
    },
  });

  profiles.push({
    start: {
      x: 0,
      y: poly[poly.length - 1].y,
    },
    end: {
      x: 0,
      y: poly[poly.length - 1].y,
    },
  });

  // dotted line and background
  svgGroup
    .createRect({
      x: leftEdgeOffset,
      y: 0,
      width: 30,
      height: containerPosition.h,
    })
    .setFill([255, 255, 255, 0.8]);
  svgGroup
    .createLine({
      x1: leftEdgeOffset + 20,
      y1: view.convertGlobalToLocal(poly[0]).y,
      x2: leftEdgeOffset + 20,
      y2: view.convertGlobalToLocal(poly[poly.length - 1]).y,
    })
    .setStroke({ color: 'black', style: 'Dash' });
  svgGroup
    .createLine({
      x1: leftEdgeOffset + 15,
      y1: view.convertGlobalToLocal(poly[0]).y,
      x2: leftEdgeOffset + 25,
      y2: view.convertGlobalToLocal(poly[0]).y,
    })
    .setStroke({ color: 'black' });
  svgGroup
    .createLine({
      x1: leftEdgeOffset + 15,
      y1: view.convertGlobalToLocal(poly[poly.length - 1]).y,
      x2: leftEdgeOffset + 25,
      y2: view.convertGlobalToLocal(poly[poly.length - 1]).y,
    })
    .setStroke({ color: 'black' });

  for (let i = 0; i < profiles.length - 1; i++) {
    if (i > 0) {
      const y = view.convertGlobalToLocal(profiles[i].start).y;
      svgGroup
        .createLine({
          x1: leftEdgeOffset + 15,
          y1: y,
          x2: leftEdgeOffset + 25,
          y2: y,
        })
        .setStroke({ color: 'black' });
    }

    const length = Math.abs(Math.round((profiles[i].start.y - profiles[i + 1].start.y) / vpx2cm));
    const textLabel = numberFormatter.formatOutput(cmToMm(length), 'feet_inch_fraction');

    const text = svgGroup
      .createText({
        x: leftEdgeOffset + 5,
        y: (view.convertGlobalToLocal(profiles[i].start).y + view.convertGlobalToLocal(profiles[i + 1].start).y) / 2,
        text: textLabel,
        align: 'middle',
      })
      .setFill('#000')
      .setFont({
        family: 'sans-serif',
        size: '12px',
      });

    rotateText(text, -90);
  }
}

export function renderHorizontalHelperMeasurements(points, mousepoint, svgGroup, view) {
  const g = com.parkside.measure_geometry;
  const poly = g.arrayOfPointsSort(points, 'x');
  const profiles = [];
  const containerPosition = dojo.position(view.canvasElement, true);
  const vpx2cm = 1; //TODO Review
  const numberFormatter = new NumberFormatter({});

  // add area borders also to profile array for simpler distance calculation
  profiles.splice(0, 0, {
    start: {
      x: poly[0].x,
      y: 0,
    },
    end: {
      x: poly[0].x,
      y: 0,
    },
  });

  profiles.push({
    start: {
      x: mousepoint.x,
      y: mousepoint.y,
    },
    end: {
      x: mousepoint.x,
      y: mousepoint.y,
    },
  });

  profiles.push({
    start: {
      x: poly[poly.length - 1].x,
      y: 0,
    },
    end: {
      x: poly[poly.length - 1].x,
      y: 0,
    },
  });

  // dotted line and background

  svgGroup
    .createRect({
      x: 65,
      y: 0,
      width: containerPosition.w - 110,
      height: 30,
    })
    .setFill([255, 255, 255, 0.8]);
  svgGroup
    .createLine({
      x1: view.convertGlobalToLocal(poly[0]).x,
      y1: 25,
      x2: view.convertGlobalToLocal(poly[poly.length - 1]).x,
      y2: 25,
    })
    .setStroke({ color: 'black', style: 'Dash' });
  svgGroup
    .createLine({
      x1: view.convertGlobalToLocal(poly[0]).x,
      y1: 20,
      x2: view.convertGlobalToLocal(poly[0]).x,
      y2: 30,
    })
    .setStroke({ color: 'black' });
  svgGroup
    .createLine({
      x1: view.convertGlobalToLocal(poly[poly.length - 1]).x,
      y1: 20,
      x2: view.convertGlobalToLocal(poly[poly.length - 1]).x,
      y2: 30,
    })
    .setStroke({ color: 'black' });

  for (let i = 0; i < profiles.length - 1; i++) {
    if (i > 0) {
      const x = view.convertGlobalToLocal(profiles[i].start).x;
      svgGroup
        .createLine({
          x1: x,
          y1: 20,
          x2: x,
          y2: 30,
        })
        .setStroke({ color: 'black' });
    }

    const length = Math.abs(Math.round((profiles[i].start.x - profiles[i + 1].start.x) / vpx2cm));
    const textLabel = numberFormatter.formatOutput(cmToMm(length), 'feet_inch_fraction');

    svgGroup
      .createText({
        x: (view.convertGlobalToLocal(profiles[i].start).x + view.convertGlobalToLocal(profiles[i + 1].start).x) / 2,
        y: 15,
        text: textLabel,
        align: 'middle',
      })
      .setFill('#000')
      .setFont({
        family: 'sans-serif',
        size: '12px',
      });
  }
}

function rotateText(textShape, degree) {
  const bbox = textShape.getBoundingBox();
  if (!bbox) return;
  const rotatex = bbox.x + bbox.width * 0.5;
  const rotatey = bbox.y + bbox.height * 0.5;
  textShape.setTransform([dojox.gfx.matrix.rotategAt(degree, rotatex, rotatey)]);
}
